import kr from 'Kr/kr';
import HTMLClass from 'Kr/utils/HTMLClass';

export default class BSIcons extends kr.Module
{
    init() {
        this._icons = document.querySelectorAll('.bs-icon[icon]');
        this.iconsArray = [];
        for (let icon of this._icons) {
            const code = icon.getAttribute('icon');
            if (this.iconsArray.indexOf(code) == -1) {
                this.iconsArray.push(code);
            }
        }

        const style = document.createElement('style');
        style.id='bs-icon-style';
        let iconsHTML = '';

        for (let code of this.iconsArray) {
            iconsHTML += `\n.bs-icon[icon="${code}"]:before {content: '\\${code}'}`;
        }
        style.innerHTML = iconsHTML;
        this.app.dom.$body.appendChild(style);
    }
}